import React from "react";
import { useTheme } from "@mui/material/styles";

const PreviewTemplateIcon = ({ color }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.dark;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.465"
      height="37.512"
      viewBox="0 0 29.465 37.512"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_6629"
            data-name="Rectangle 6629"
            width="29.465"
            height="37.512"
            transform="translate(0 0)"
            fill={color}
          />
        </clipPath>
      </defs>
      <g id="Group_7180" data-name="Group 7180" transform="translate(0 0)">
        <g id="Group_7179" data-name="Group 7179" clipPath="url(#clip-path)">
          <path
            id="Path_8211"
            data-name="Path 8211"
            d="M25.965,37.512h-20v-3h20a.5.5,0,0,0,.5-.5v-28h3v28a3.5,3.5,0,0,1-3.5,3.5"
            fill={color}
          />
          <path
            id="Path_8212"
            data-name="Path 8212"
            d="M18.589,29H3V3H21V18.682l3,3V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V30a2,2,0,0,0,2,2H21.588Z"
            fill={color}
          />
          <path
            id="Path_8213"
            data-name="Path 8213"
            d="M22.577,24.513l.005-.005-.051-.051c-.018-.02-.037-.038-.057-.057l-4.965-4.966a6.527,6.527,0,1,0-2.133,2.11l5.085,5.085.01-.01a1.493,1.493,0,0,0,2.106-2.106M8.5,16A3.5,3.5,0,1,1,12,19.5,3.5,3.5,0,0,1,8.5,16"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export default PreviewTemplateIcon;
